import React from 'react';

import { NoSSR, Snackbar } from '@ha/dsl';
import { Alert } from 'ha/components/Alert';
import { withIntl, IntlProps } from 'ha/i18n';
import { AlertType, AlertDismissAfter } from '../types';

interface AlertObject {
  id: number;
  text: React.ReactNode;
  kind: AlertType;
  dismissAfter?: number;
}

interface Props extends IntlProps {
  alert?: AlertObject;
  onClose: (id: number) => void;
  onSendPersistentAlert: () => void;
}

interface State {
  open: boolean;
  alert?: AlertObject;
}

export class AlertbarInternal extends React.Component<Props, State> {
  state: State = { open: false, alert: undefined };

  static getDerivedStateFromProps(props: Props, state: State) {
    if (
      (!state.alert && props.alert) ||
      (state.alert && props.alert && state.alert.id !== props.alert.id)
    ) {
      return {
        open: true,
        alert: props.alert,
      };
    }

    return null;
  }

  componentDidMount() {
    this.props.onSendPersistentAlert();
  }

  handleClose = (e?: unknown, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      open: false,
    });
  };

  handleExit = () => {
    const { alert } = this.state;

    if (!alert) {
      return;
    }
    this.props.onClose(alert.id);
  };

  render() {
    const {
      intl: { T },
    } = this.props;
    const { alert } = this.state;

    if (!alert) {
      return null;
    }

    return (
      <NoSSR>
        <Snackbar
          // remount snackbar to restart autoHide
          key={alert.id}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.open}
          autoHideDuration={alert.dismissAfter || AlertDismissAfter.Default}
          onClose={this.handleClose}
          data-test-locator="Alertbar"
          TransitionProps={{
            onExited: this.handleExit,
          }}
        >
          <Alert
            message={
              typeof alert.text === 'string' ? T(alert.text) : alert.text
            }
            variant={alert.kind}
            onClose={this.handleClose}
          />
        </Snackbar>
      </NoSSR>
    );
  }
}

const Alertbar = withIntl(AlertbarInternal);
export { Alertbar };
